import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import cm from 'classnames';

import { FolderType } from 'services/folders.service';
import { selectFolder } from 'components/app/_mediator/app-data.slice';
import { setSelectedFolder } from '../_mediator/projects.slice';
import { UNFILED_FOLDER_ID, CUSTOM_FOLDER_ID, ALL_ACTIVE_FOLDER_ID } from '../_mediator/projects.params';

import { Select } from 'components/UI/select/select';
import styles from './_elements.module.scss';

interface Props {
  className?: string;
}

export const HeaderFolders = ({ className }: Props) => {
  const user = useAppSelector((state) => state.app__data.user);
  const folders = useAppSelector((state) => state.app__data.folders);
  const folderData = useAppSelector(selectFolder);
  const dispatch = useAppDispatch();
  const [selected, setSelected] = useState<number>(UNFILED_FOLDER_ID);

  const customFolder = useMemo(() => {
    return folders?.find((el) => el.type === FolderType.Custom);
  }, [folders]);

  const baseOptions = useMemo(() => {
    if (!user) return [];
    return [
      { value: ALL_ACTIVE_FOLDER_ID, label: 'All Active' },
      { value: UNFILED_FOLDER_ID, label: 'Unfiled' },
      ...user.folders
        .filter((el) => [FolderType.Trash, FolderType.Archive].includes(el.type))
        .map((el) => ({ value: el.id, label: el.name })),
    ];
  }, [user]);

  const options = useMemo(() => {
    if (!folders) return [];
    return customFolder ? [...baseOptions, { value: CUSTOM_FOLDER_ID, label: 'Custom' }] : baseOptions;
  }, [baseOptions, folders?.length, customFolder]);

  const selectFolderHandler = (value: number) => {
    setSelected(value);
    if (value === CUSTOM_FOLDER_ID && customFolder) {
      dispatch(setSelectedFolder(customFolder.id));
      return;
    }
    dispatch(setSelectedFolder(value));
  };

  useEffect(() => {
    if (!folderData) {
      if (selected === CUSTOM_FOLDER_ID) selectFolderHandler(UNFILED_FOLDER_ID);
    } else if (folderData.type === FolderType.Custom) setSelected(CUSTOM_FOLDER_ID);
    else setSelected(folderData.id);
  }, [folderData]);

  return (
    <Select
      options={options}
      className={cm(styles.HeaderFolders, className)}
      onChange={(e) => selectFolderHandler(Number(e.target.value))}
      value={selected}
    />
  );
};
